import styled from "styled-components";
import {
  Attribute,
  AttributeGroup,
  AttributeProperty,
  ComponentProps,
  ConfigContext,
} from "react-builder";
import { ContainerAttributes } from "react-builder";
import { useContext, useEffect, useState } from "react";
import { useProductApi } from "../custom-hooks/useProductApi";
import { Subtitle } from "../types/multimedia-types";

@AttributeGroup({ title: "SecureVideoPlayer", blockName: "SecureVideoPlayer" })
export class SecureVideoPlayerAttributes extends Attribute {
  @AttributeProperty({ type: "String" })
  videoId?: string;

  @AttributeProperty({ type: "String" })
  subtitles?: string;

  @AttributeProperty({ type: "Boolean" })
  autoPlay: boolean = false;

  @AttributeProperty({ type: "Boolean" })
  controls: boolean = true;

  @AttributeProperty({ type: "Boolean" })
  loop: boolean = false;

  @AttributeProperty({ type: "Boolean" })
  muted: boolean = false;

  @AttributeProperty({ type: "Image" })
  poster?: string;

  @AttributeProperty({ type: "Object", cssTarget: "" })
  container: ContainerAttributes = new ContainerAttributes();
}

const SecureVideoPlayerTheme = styled.div(
  (props: { attributes: SecureVideoPlayerAttributes }) => `

    ${props.attributes.toCSS()}

    video{
        width: 100%;
        height: 100%;
    }
`
);

export function SecureVideoPlayer(props: ComponentProps<SecureVideoPlayerAttributes>) {
  const [secureVideoLink, setSecureVideoLink] = useState<{ link: string; expiry: number }>();
  const content = useContext(ConfigContext);
  const secureFileApi = useProductApi<{ link: string; expiry: number }>();
  const parsedVideoId = props.attributes.videoId
    ? content.getContent(props.attributes.videoId)
    : "";
  const subtitles: Subtitle[] = props.attributes.subtitles
    ? content.getContent(props.attributes.subtitles)
    : undefined;
  // console.log("parsedVideoId", parsedVideoId);

  useEffect(() => {
    if (!secureFileApi) return;
    const fetchLink = async () => {
      try {
        const response = await secureFileApi.single(`File/${parsedVideoId}/secure`);
        // console.log("response.link", response.link);
        setSecureVideoLink(response);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };
    fetchLink();
  }, [secureFileApi, parsedVideoId]);
  // console.log("secureVideoLink", secureVideoLink);

  return (
    <SecureVideoPlayerTheme {...props} attributes={props.attributes}>
      {secureVideoLink && (
        <video
          src={secureVideoLink.link}
          autoPlay={props.attributes.autoPlay}
          controls={props.attributes.controls}
          loop={props.attributes.loop}
          muted={props.attributes.muted}
          poster={props.attributes.poster}
          controlsList="nodownload"
          crossOrigin="anonymous"
        >
          {subtitles &&
            subtitles.map((subtitle, index) => (
              <track
                key={index}
                src={subtitle.file.url}
                label={subtitle.label}
                kind="subtitles"
                srcLang={subtitle.lang}
              />
            ))}
          Your browser does not support the video tag.
        </video>
      )}
    </SecureVideoPlayerTheme>
  );
}

SecureVideoPlayer.prototype.Props = SecureVideoPlayerAttributes;

export default SecureVideoPlayer;
